import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", {
    class: "w-20 text-black text-left mt-10 cursor-pointer",
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($props.type === 'custom' ? $setup.goRoute() : $setup.backHistory()))
  }, [
    _createVNode(_component_fa, { icon: "angle-left" }),
    _createTextVNode(" Anterior ")
  ]))
}